import React, { forwardRef } from 'react';
import { UIHeading4 } from '@cian/ui-kit';

import { RulesItemWithTooltip } from '../RulesItemWithTooltip';
import * as s from './Rules.css';

/**
 * Компонент правил расчета
 */
export const Rules = forwardRef((_: unknown, ref: React.RefObject<HTMLDivElement>) => {
  return (
    <div ref={ref} className={s['wrapper']}>
      <div className={s['inner-wrapper']}>
        <UIHeading4>Рейтинг складывается из суммы баллов:</UIHeading4>

        <ul className={s['items']}>
          <li className={s['item']}>
            <span>Совет</span>
            <span>+1</span>
          </li>

          <li className={s['item']}>
            <span>Лучший совет</span>
            <span>+5</span>
          </li>

          <li className={s['item']}>
            <RulesItemWithTooltip
              title={'Популярный пост'}
              count={10}
              description={'Разница положительных и отрицательных оценок в 5 баллов и больше'}
            />
          </li>

          <li className={s['item']}>
            <span>Пост в блоге</span>
            <span>+2</span>
          </li>

          <li className={s['item']}>
            <span>Отзыв о ЖК</span>
            <span>+1</span>
          </li>

          <li className={s['item']}>
            <RulesItemWithTooltip
              title={'Популярный отзыв о ЖК'}
              count={10}
              description={'Разница положительных и отрицательных оценок в 5 баллов и больше'}
            />
          </li>
        </ul>
      </div>
    </div>
  );
});

Rules.displayName = 'Rules';
